import PropTypes from "prop-types";

export const defaultListPropTypes = {
  "onChange": PropTypes.func,
  "onFetch": PropTypes.func,
  "data": PropTypes.any,
  "loading": PropTypes.bool,
  "error": PropTypes.any
};
